export const classification = [
  {
    id: 1,
    level: 0,
    name: '艺术品',
    sort: 1,
    parentId: 0,
    isParent: 1,
  },
  {
    id: 101,
    level: 1,
    name: '油画',
    sort: 1,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 102,
    level: 1,
    name: '丙烯',
    sort: 2,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 103,
    level: 1,
    name: '水彩',
    sort: 3,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 104,
    level: 1,
    name: '雕塑',
    sort: 4,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 105,
    level: 1,
    name: '装置',
    sort: 5,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 106,
    level: 1,
    name: '国画',
    sort: 6,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 107,
    level: 1,
    name: '书法',
    sort: 7,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 108,
    level: 1,
    name: '篆刻',
    sort: 8,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 109,
    level: 1,
    name: '插画',
    sort: 9,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 110,
    level: 1,
    name: '素描',
    sort: 10,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 111,
    level: 1,
    name: '漆画',
    sort: 11,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 112,
    level: 1,
    name: '壁画',
    sort: 12,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 113,
    level: 1,
    name: '综合材料',
    sort: 13,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 114,
    level: 1,
    name: '摄影',
    sort: 14,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 115,
    level: 1,
    name: '版画',
    sort: 15,
    parentId: 1,
    isParent: 1,
  },
  {
    id: 11501,
    level: 2,
    name: '数码版画',
    sort: 1,
    parentId: 115,
    isParent: 0,
  },
  {
    id: 11502,
    level: 2,
    name: '丝网版画',
    sort: 2,
    parentId: 115,
    isParent: 0,
  },
  {
    id: 11503,
    level: 2,
    name: '木刻版画',
    sort: 3,
    parentId: 115,
    isParent: 0,
  },
  {
    id: 11504,
    level: 2,
    name: '石版版画',
    sort: 4,
    parentId: 115,
    isParent: 0,
  },
  {
    id: 11505,
    level: 2,
    name: '其他版画',
    sort: 5,
    parentId: 115,
    isParent: 0,
  },
  {
    id: 116,
    level: 1,
    name: '新媒体',
    sort: 16,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 117,
    level: 1,
    name: '潮玩',
    sort: 17,
    parentId: 1,
    isParent: 0,
  },
  {
    id: 2,
    level: 0,
    name: '衍生品',
    sort: 2,
    parentId: 0,
    isParent: 1,
  },
  {
    id: 201,
    level: 1,
    name: '雕塑摆件',
    sort: 1,
    parentId: 2,
    isParent: 0,
  },
  {
    id: 202,
    level: 1,
    name: '箱包',
    sort: 2,
    parentId: 2,
    isParent: 1,
  },
  {
    id: 20201,
    level: 2,
    name: '帆布袋',
    sort: 1,
    parentId: 202,
    isParent: 0,
  },
  {
    id: 20202,
    level: 2,
    name: '单肩包',
    sort: 2,
    parentId: 202,
    isParent: 0,
  },
  {
    id: 20203,
    level: 2,
    name: '双肩包',
    sort: 3,
    parentId: 202,
    isParent: 0,
  },
  {
    id: 20204,
    level: 2,
    name: '行李箱',
    sort: 4,
    parentId: 202,
    isParent: 0,
  },
  {
    id: 203,
    level: 1,
    name: '餐具',
    sort: 3,
    parentId: 2,
    isParent: 1,
  },
  {
    id: 20301,
    level: 2,
    name: '水杯',
    sort: 1,
    parentId: 203,
    isParent: 0,
  },
  {
    id: 20302,
    level: 2,
    name: '酒杯',
    sort: 2,
    parentId: 203,
    isParent: 0,
  },
  {
    id: 20303,
    level: 2,
    name: '咖啡杯',
    sort: 3,
    parentId: 203,
    isParent: 0,
  },
  {
    id: 20304,
    level: 2,
    name: '盘子',
    sort: 4,
    parentId: 203,
    isParent: 0,
  },
  {
    id: 20305,
    level: 2,
    name: '茶具',
    sort: 5,
    parentId: 203,
    isParent: 0,
  },
  {
    id: 204,
    level: 1,
    name: '服饰',
    sort: 4,
    parentId: 2,
    isParent: 1,
  },
  {
    id: 20401,
    level: 2,
    name: '丝巾/围巾',
    sort: 1,
    parentId: 204,
    isParent: 0,
  },
  {
    id: 20402,
    level: 2,
    name: 'T恤',
    sort: 2,
    parentId: 204,
    isParent: 0,
  },
  {
    id: 20403,
    level: 2,
    name: '卫衣',
    sort: 3,
    parentId: 204,
    isParent: 0,
  },
  {
    id: 205,
    level: 1,
    name: '家居',
    sort: 5,
    parentId: 2,
    isParent: 1,
  },
  {
    id: 20501,
    level: 2,
    name: '抱枕',
    sort: 1,
    parentId: 205,
    isParent: 0,
  },
  {
    id: 20502,
    level: 2,
    name: '钟表',
    sort: 2,
    parentId: 205,
    isParent: 0,
  },
  {
    id: 20503,
    level: 2,
    name: '床上用品',
    sort: 3,
    parentId: 205,
    isParent: 0,
  },
  {
    id: 206,
    level: 1,
    name: '鼠标垫',
    sort: 6,
    parentId: 2,
    isParent: 0,
  },
  {
    id: 207,
    level: 1,
    name: '文具',
    sort: 7,
    parentId: 2,
    isParent: 0,
  },
  {
    id: 208,
    level: 1,
    name: '手机壳',
    sort: 8,
    parentId: 2,
    isParent: 0,
  },
  {
    id: 3,
    level: 0,
    name: '工艺品',
    sort: 3,
    parentId: 0,
    isParent: 1,
  },
  {
    id: 301,
    level: 1,
    name: '茶具茶叶',
    sort: 1,
    parentId: 3,
    isParent: 1,
  },
  {
    id: 30101,
    level: 2,
    name: '茶壶',
    sort: 1,
    parentId: 301,
    isParent: 0,
  },
  {
    id: 30102,
    level: 2,
    name: '茶杯',
    sort: 2,
    parentId: 301,
    isParent: 0,
  },
  {
    id: 30103,
    level: 2,
    name: '茶具套装',
    sort: 3,
    parentId: 301,
    isParent: 0,
  },
  {
    id: 30104,
    level: 2,
    name: '茶叶罐',
    sort: 4,
    parentId: 301,
    isParent: 0,
  },
  {
    id: 30105,
    level: 2,
    name: '茶宠',
    sort: 5,
    parentId: 301,
    isParent: 0,
  },
  {
    id: 30106,
    level: 2,
    name: '茶具配件',
    sort: 6,
    parentId: 301,
    isParent: 0,
  },
  {
    id: 30107,
    level: 2,
    name: '茶叶',
    sort: 7,
    parentId: 301,
    isParent: 0,
  },
  {
    id: 302,
    level: 1,
    name: '陈设雕刻',
    sort: 2,
    parentId: 3,
    isParent: 1,
  },
  {
    id: 30201,
    level: 2,
    name: '石雕',
    sort: 1,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30202,
    level: 2,
    name: '青铜雕刻',
    sort: 2,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30203,
    level: 2,
    name: '木雕',
    sort: 3,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30204,
    level: 2,
    name: '根雕',
    sort: 4,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30205,
    level: 2,
    name: '竹雕',
    sort: 5,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30206,
    level: 2,
    name: '漆器雕漆',
    sort: 6,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30207,
    level: 2,
    name: '花器',
    sort: 7,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30208,
    level: 2,
    name: '香器',
    sort: 8,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30209,
    level: 2,
    name: '观赏摆件',
    sort: 9,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30210,
    level: 2,
    name: '金银器',
    sort: 10,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 30211,
    level: 2,
    name: '陶瓷器物',
    sort: 11,
    parentId: 302,
    isParent: 0,
  },
  {
    id: 303,
    level: 1,
    name: '宗教文化',
    sort: 3,
    parentId: 3,
    isParent: 0,
  },
  {
    id: 304,
    level: 1,
    name: '珐琅/花丝',
    sort: 4,
    parentId: 3,
    isParent: 0,
  },
  {
    id: 305,
    level: 1,
    name: '刺绣',
    sort: 5,
    parentId: 3,
    isParent: 0,
  },
  {
    id: 306,
    level: 1,
    name: '丝绸/云锦',
    sort: 6,
    parentId: 3,
    isParent: 0,
  },
  {
    id: 307,
    level: 1,
    name: '瓷板画',
    sort: 7,
    parentId: 3,
    isParent: 0,
  },
  {
    id: 4,
    level: 0,
    name: '文玩',
    sort: 4,
    parentId: 0,
    isParent: 1,
  },
  {
    id: 401,
    level: 1,
    name: '文玩把件',
    sort: 1,
    parentId: 4,
    isParent: 1,
  },
  {
    id: 40101,
    level: 2,
    name: '菩提珠串',
    sort: 2,
    parentId: 401,
    isParent: 0,
  },
  {
    id: 40102,
    level: 2,
    name: '木质珠串',
    sort: 2,
    parentId: 401,
    isParent: 0,
  },
  {
    id: 40103,
    level: 2,
    name: '核桃核雕',
    sort: 3,
    parentId: 401,
    isParent: 0,
  },
  {
    id: 40104,
    level: 2,
    name: '其他把件',
    sort: 4,
    parentId: 401,
    isParent: 0,
  },
  {
    id: 402,
    level: 1,
    name: '文玩杂项',
    sort: 2,
    parentId: 4,
    isParent: 1,
  },
  {
    id: 40201,
    level: 2,
    name: '烟具',
    sort: 1,
    parentId: 402,
    isParent: 0,
  },
  {
    id: 40202,
    level: 2,
    name: '黄花梨',
    sort: 2,
    parentId: 402,
    isParent: 0,
  },
  {
    id: 40203,
    level: 2,
    name: '小叶紫檀',
    sort: 3,
    parentId: 402,
    isParent: 0,
  },
  {
    id: 40204,
    level: 2,
    name: '青铜杂件',
    sort: 4,
    parentId: 402,
    isParent: 0,
  },
  {
    id: 403,
    level: 1,
    name: '文房用品',
    sort: 3,
    parentId: 4,
    isParent: 1,
  },
  {
    id: 40301,
    level: 2,
    name: '墨砚/印泥',
    sort: 1,
    parentId: 403,
    isParent: 0,
  },
  {
    id: 40302,
    level: 2,
    name: '纸/笔',
    sort: 2,
    parentId: 403,
    isParent: 0,
  },
  {
    id: 40303,
    level: 2,
    name: '镇尺笔架',
    sort: 3,
    parentId: 403,
    isParent: 0,
  },
  {
    id: 40304,
    level: 2,
    name: '篆刻章料',
    sort: 4,
    parentId: 403,
    isParent: 0,
  },
  {
    id: 404,
    level: 1,
    name: '钱币邮票',
    sort: 4,
    parentId: 4,
    isParent: 0,
  },
  {
    id: 5,
    level: 0,
    name: '翡翠玉石',
    sort: 5,
    parentId: 0,
    isParent: 1,
  },
  {
    id: 501,
    level: 1,
    name: '和田玉',
    sort: 1,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 502,
    level: 1,
    name: '翡翠',
    sort: 2,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 503,
    level: 1,
    name: '翡翠原石',
    sort: 3,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 504,
    level: 1,
    name: '古珠',
    sort: 4,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 505,
    level: 1,
    name: '古玉',
    sort: 5,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 506,
    level: 1,
    name: '南红',
    sort: 6,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 507,
    level: 1,
    name: '松石',
    sort: 7,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 508,
    level: 1,
    name: '琥珀蜜蜡',
    sort: 8,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 509,
    level: 1,
    name: '珍珠',
    sort: 9,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 510,
    level: 1,
    name: '水晶',
    sort: 10,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 511,
    level: 1,
    name: '金银饰品',
    sort: 11,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 512,
    level: 1,
    name: '贵重宝石',
    sort: 12,
    parentId: 5,
    isParent: 0,
  },
  {
    id: 6,
    level: 0,
    name: '出版物',
    sort: 6,
    parentId: 0,
    isParent: 1,
  },
  {
    id: 601,
    level: 1,
    name: '图书',
    sort: 1,
    parentId: 6,
    isParent: 0,
  },
  {
    id: 602,
    level: 1,
    name: '日历',
    sort: 2,
    parentId: 6,
    isParent: 0,
  },
];
